import { WorkerStatusFilter } from 'api/assignment/getCalendarEvents'
import { QueryKeys } from 'queries/types'

const ROOT = 'assignment'

export const assignmentKeys = {
  list: () => [ROOT, 'list'],

  detail: {
    byId: (id?: number) => [ROOT, 'detail', id],
    shifts: (id: number) => [ROOT, 'detail', id, 'shifts'],
    calendarEvents: (
      id: number,
      date: Date,
      workStatus: WorkerStatusFilter
    ) => [
      ROOT,
      'detail',
      id,
      'calendar-events',
      date.toISOString(),
      workStatus,
    ],
  },
} satisfies QueryKeys
